<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Epigraph">
<blockquote class="epigraph">
<p class="epitxt"><span aria-label="page ix" id="page_ix" role="doc-pagebreak"><span aria-label="page x" id="page_x" role="doc-pagebreak">“T<span class="smallcaps">HE UNIVERSE</span></span></span></p>
<p class="epitxt1"><i>is not required to be</i></p>
<p class="epitxt"><span class="smallcaps">IN PERFECT HARMONY</span></p>
<p class="epitxt1"><i>with human ambition.”</i></p>
<p class="epinam">—Carl Sagan</p>
</blockquote>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// epigraph.vue?b820f4a0